var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReceiptIcon = function SvgReceiptIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#receipt-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.436 0h5.129c.633 0 1.16 0 1.593.035.45.037.873.117 1.272.32a3.259 3.259 0 0 1 1.425 1.425c.203.4.283.822.32 1.272.035.432.035.96.035 1.593v10.466a.889.889 0 0 1-1.412.719l-1.624-1.181-1.446 1.156a.889.889 0 0 1-1.078.025L8 14.63l-1.65 1.2a.889.889 0 0 1-1.078-.025L3.826 14.65 2.202 15.83a.889.889 0 0 1-1.412-.719V4.645c0-.633 0-1.161.035-1.593.037-.45.117-.873.32-1.272A3.26 3.26 0 0 1 2.57.355c.4-.203.822-.283 1.272-.32C4.274 0 4.802 0 5.436 0ZM3.987 1.807c-.34.028-.503.078-.61.132a1.481 1.481 0 0 0-.648.648c-.054.107-.104.27-.132.61-.028.35-.03.806-.03 1.484v8.684l.762-.553a.889.889 0 0 1 1.078.025l1.446 1.156 1.624-1.181a.889.889 0 0 1 1.046 0l1.624 1.181 1.446-1.156a.889.889 0 0 1 1.078-.025l.761.554V4.68c0-.678 0-1.133-.03-1.484-.027-.34-.077-.503-.131-.61a1.482 1.482 0 0 0-.648-.648c-.107-.054-.27-.104-.61-.132-.35-.029-.806-.03-1.485-.03H5.472c-.679 0-1.134.001-1.485.03Zm7.407 2.404a.889.889 0 0 1 0 1.257L7.838 9.024a.889.889 0 0 1-1.257 0l-1.58-1.58a.889.889 0 1 1 1.257-1.258l.952.952 2.927-2.927a.889.889 0 0 1 1.257 0Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "receipt-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

export default SvgReceiptIcon;